<template>
  <div class="login-page">
    <!-- LOGO 占位（居中大），移出白色卡片以显示页面背景 -->
    <div class="login-logo-wrap">
      <img class="login-logo-img" :src="logoUrl" alt="LOGO" />
    </div>

    <div class="login-card">
      <div class="login-header">
        <div class="title">航小梦国旅</div>
        <div class="sub">火箭发射观礼平台 · 游客信息管理系统</div>
      </div>

      <div class="login-body">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="管理员账号" prop="username" required>
            <el-input v-model.trim="form.username" placeholder="请输入管理员账号" autocomplete="username" />
          </el-form-item>

          <el-form-item label="密码" prop="password" required>
            <el-input
              v-model="form.password"
              placeholder="请输入密码"
              show-password
              autocomplete="current-password"
              @keyup.enter.native="onSubmit"
            />
          </el-form-item>

          <div class="actions">
            <el-button type="primary" class="login-btn" :loading="loading" @click="onSubmit">
              登录系统
            </el-button>
          </div>
        </el-form>

        <div class="footer">
          <div class="copyright">© 2026 航小梦国旅｜版本 2.1.0</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../../api'

const AUTH_KEY = 'yy_auth'

export default {
  name: 'LoginPage',
  computed: {
    logoUrl() {
      return './logo.png'
    }
  },
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        this.loading = true
        try {
          const { username, password } = this.form
          const data = await login({ username, password })

          const auth = {
            token: data.token,
            user: data.user,
            loginAt: Date.now()
          }
          localStorage.setItem(AUTH_KEY, JSON.stringify(auth))

          const role = (data.user && data.user.role) || ''
          const homeMap = {
            '超级管理员': '/visitor-input',
            '游客录入员': '/visitor-input',
            '票务核销员': '/ticket-verify',
            '财务人员': '/finance'
          }
          const home = homeMap[role] || '/visitor-input'

          const redirect = (this.$route.query && this.$route.query.redirect) || home
          this.$message.success('登录成功')
          this.$router.replace(redirect)
        } catch (e) {
          this.$message.error(e.message || '登录失败')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e9eef6;
}

.login-card {
  width: 380px;
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  background: #fff;
  margin-top: 24px;
  position: relative;
}

.login-logo-wrap {
  background: transparent;
  padding: 18px 0 8px;
  display: flex;
  justify-content: center;
  z-index: 2;
  margin-bottom: 12px;
}

.login-logo {
  width: 220px;
  height: 90px;
  border-radius: 10px;
  border: 2px dashed rgba(31, 122, 224, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(31, 122, 224, 0.9);
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 2px;
  background: rgba(31, 122, 224, 0.06);
}

.login-logo-img {
  width: 360px;
  height: 140px;
  object-fit: contain;
  border-radius: 8px;
}

.login-header {
  padding: 18px 18px 14px;
  background: #1f7ae0;
  color: #fff;
  text-align: center;
}

.title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}

.sub {
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.9;
}

.login-body {
  padding: 18px;
}

.actions {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.login-btn {
  width: 140px;
}

.footer {
  margin-top: 14px;
  text-align: center;
  color: #909399;
  font-size: 12px;
}

.tips {
  margin-top: 6px;
}
</style>
